import React, { useCallback, useMemo, useState } from 'react';
import ReportDetailModal from './ReportDetailModal';

/**
 * Row drill-down for a report, in two lines.
 *
 *   const drill = useDrill();
 *   <ReportTable onRowClick={(r) => drill.open({ type: 'patient', mrn: r.mrn })} ... />
 *   {drill.node}
 *
 * `open` takes the drill spec straight through to the endpoint, so which drill a row opens is
 * declared where the table is, and no report holds modal state of its own. Passing a falsy spec is
 * ignored, which lets a report skip rows that have nothing to open.
 */
const useDrill = () => {
  const [spec, setSpec] = useState(null);

  const open = useCallback((next) => {
    if (next && next.type) setSpec(next);
  }, []);

  const close = useCallback(() => setSpec(null), []);

  // Keyed on the spec so re-opening a different row refetches rather than showing stale detail.
  const node = useMemo(
    () => (spec ? <ReportDetailModal key={JSON.stringify(spec)} spec={spec} onClose={close} /> : null),
    [spec, close]
  );

  return { open, close, node };
};

export default useDrill;
